/**
 * @generated SignedSource<<a472a2302cfdd92ee07b3cc9c4cc67ea>>
 * @relayHash 02e5694eae05d544c06e2fa66565189c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 14f9f5f6d6e0c64e5e92a784821105c630f04dd5684cd3348558eb13e8e4ebac

import type { ConcreteRequest } from 'relay-runtime';
export type useContentInfoContentOwnershipContentInfoQuery$variables = {
  contentId: string;
};
export type useContentInfoContentOwnershipContentInfoQuery$data = {
  readonly singleContent: {
    readonly id: string | null | undefined;
    readonly status: string | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
};
export type useContentInfoContentOwnershipContentInfoQuery = {
  response: useContentInfoContentOwnershipContentInfoQuery$data;
  variables: useContentInfoContentOwnershipContentInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentInfoContentOwnershipContentInfoQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentInfoContentOwnershipContentInfoQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "02e5694eae05d544c06e2fa66565189c",
    "id": "14f9f5f6d6e0c64e5e92a784821105c630f04dd5684cd3348558eb13e8e4ebac",
    "metadata": {},
    "name": "useContentInfoContentOwnershipContentInfoQuery",
    "operationKind": "query",
    "text": "query useContentInfoContentOwnershipContentInfoQuery($contentId:ID!){singleContent(id:$contentId){id,title,status}}"
  }
};
})();

(node as any).hash = "bbc83213ee3157004ed18cf9c0a1713f";

export default node;
